/* KIS Mijn account (2026-10-14). Hoort bij sections/kis-account.liquid, snippets/kis-account-content.liquid en
   assets/kis-account.css.
   - <kis-account-drawer>: de accountlaag (<dialog>, showModal): openen via [data-kis-account-open] (header-icoon,
     accountnaam in het mobiele menu), sluiten via [data-kis-account-close], Esc, klik op de achtergrond. Native dialog =
     focus blijft in de laag, de rest is inert; scroll-lock op <html>; aria-expanded op alle triggers.
   - <kis-account-wishlist>: teller + miniaturen uit window.KISWishlist (assets/kis-wishlist.js, event kis:wishlist:change).
   - <kis-account-size>: jouw maat, één maat in localStorage kis:size (alleen onthouden en tonen), event kis:size:change.
   - Terug na inloggen: ?kis=account in de url opent de laag en wordt daarna uit de url gehaald.
   - Gedeelde voorbeeldlink (xxx.shopifypreview.com): inloglinks via het vaste winkeldomein (Shopify.shop), anders geeft
     Shopify 'Verkeerde redirect_uri'. Zie snippets/kis-account-url.liquid.
   API: window.KISAccount { open(trigger), close(), isOpen(), size: { get, set, clear, sync(email) } }. */
(function () {
  'use strict';
  if (window.KISAccount) return;

  var SIZE_KEY = 'kis:size';
  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  function storeGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function storeSet(key, value) {
    try {
      if (value === null) window.localStorage.removeItem(key);
      else window.localStorage.setItem(key, value);
    } catch (e) {}
  }

  function emit(name, detail) {
    try {
      document.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
    } catch (e) {}
  }

  /* ---- Jouw maat ---------------------------------------------------------------------------------------------- */
  /* Luc 21 okt: de gekozen maat ook naar Klaviyo als profiel-eigenschap "Maat" (alleen ingelogd; e-mail uit data-customer-email
     op <kis-account-size>), zodat het team daar een segment per maat op kan maken (bv. 'jouw maat is terug'). */
  /* 23 okt (Luc: "sommige mensen hebben hun maat al gekozen, met Klaviyo moeten we ze kunnen koppelen"): de maat gaat ook mee
     met een e-mailadres uit een inschrijving (Klaviyo-formulier, Black Friday early access), en bij een ingelogde klant wordt
     een eerder (uitgelogd) gekozen maat één keer per sessie alsnog naar Klaviyo gestuurd. */
  var SYNC_KEY = 'kis:size-synced';
  function klaviyoIdentify(props) {
    try {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify(props);
      else { window._learnq = window._learnq || []; window._learnq.push(['identify', props]); }
    } catch (e) {}
  }
  function customerEmail() {
    var el = document.querySelector('[data-customer-email]');
    return (el && el.getAttribute('data-customer-email')) || '';
  }
  function pushSizeToKlaviyo(size, email) {
    email = String(email || customerEmail() || '').trim();
    if (!email) return false;
    klaviyoIdentify({ $email: email, Maat: size || '' });
    try { window.sessionStorage.setItem(SYNC_KEY, (size || '') + '|' + email); } catch (e) {}
    return true;
  }
  function syncSizeOnce() {
    var size = Size.get(); var email = customerEmail();
    if (!size || !email) return;
    var done = null; try { done = window.sessionStorage.getItem(SYNC_KEY); } catch (e) {}
    if (done === size + '|' + email) return;
    pushSizeToKlaviyo(size, email);
  }
  /* Klaviyo-formulieren (pop-up, teaser, footer): bij versturen de bewaarde maat aan het nieuwe profiel hangen */
  window.addEventListener('klaviyoForms', function (e) {
    var d = e && e.detail; if (!d || d.type !== 'submit') return;
    var meta = d.metaData || {}; var email = meta.$email || meta.email || '';
    var size = Size.get(); if (email && size) pushSizeToKlaviyo(size, email);
  });

  var Size = {
    get: function () {
      var v = storeGet(SIZE_KEY);
      return v ? String(v).trim() : '';
    },
    set: function (v) {
      v = String(v || '').trim();
      storeSet(SIZE_KEY, v || null);
      emit('kis:size:change', { size: v });
      pushSizeToKlaviyo(v);
      return v;
    },
    clear: function () {
      return Size.set('');
    },
    /* maat (als die er is) aan een e-mailadres koppelen in Klaviyo; zonder e-mail: de ingelogde klant */
    sync: function (email) {
      var v = Size.get(); if (!v) return false;
      return pushSizeToKlaviyo(v, email);
    },
  };

  class KisAccountSize extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.valueEl = this.querySelector('[data-kis-size-value]');
      this.actionEl = this.querySelector('[data-kis-size-action]');
      this.clearBtn = this.querySelector('[data-kis-size-clear]');
      this.chips = Array.from(this.querySelectorAll('[data-kis-size]'));
      this.onChange = () => this.render();
      this.onStorage = (event) => {
        if (event.key === SIZE_KEY) this.render();
      };
      this.onClick = (event) => this.handleClick(event);
      this.addEventListener('click', this.onClick);
      document.addEventListener('kis:size:change', this.onChange);
      window.addEventListener('storage', this.onStorage);
      this.render();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      document.removeEventListener('kis:size:change', this.onChange);
      window.removeEventListener('storage', this.onStorage);
    }

    handleClick(event) {
      const chip = event.target.closest('[data-kis-size]');
      if (chip && this.contains(chip)) {
        const value = chip.getAttribute('data-kis-size') || '';
        Size.set(Size.get() === value ? '' : value);
        return;
      }
      if (event.target.closest('[data-kis-size-clear]')) {
        Size.clear();
        return;
      }
      if (event.target.closest('[data-kis-size-done]') && this.details) {
        this.details.open = false;
        const summary = this.details.querySelector('summary');
        if (summary) summary.focus({ preventScroll: true });
      }
    }

    render() {
      const value = Size.get();
      for (const chip of this.chips) {
        chip.setAttribute('aria-pressed', chip.getAttribute('data-kis-size') === value ? 'true' : 'false');
      }
      if (this.valueEl) {
        this.valueEl.textContent = value ? ((this.dataset.prefix || '') + ' ' + value).trim() : this.dataset.empty || '';
      }
      if (this.actionEl) {
        this.actionEl.textContent = value ? this.dataset.changeLabel || '' : this.dataset.setLabel || '';
      }
      if (this.clearBtn) {
        if (value) this.clearBtn.removeAttribute('hidden');
        else this.clearBtn.setAttribute('hidden', '');
      }
      this.classList.toggle('has-size', Boolean(value));
    }
  }

  /* ---- Verlanglijst ------------------------------------------------------------------------------------------- */
  var productCache = {};

  function productJson(handle) {
    if (productCache[handle]) return productCache[handle];
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    productCache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then((response) => (response.ok ? response.json() : null))
      .catch(() => null);
    return productCache[handle];
  }

  function sizedImage(url, width) {
    try {
      const u = new URL(url, window.location.href);
      u.searchParams.set('width', String(width));
      return u.toString();
    } catch (e) {
      return url;
    }
  }

  class KisAccountWishlist extends HTMLElement {
    connectedCallback() {
      this.textEl = this.querySelector('[data-kis-account-wishlist-text]');
      this.thumbsEl = this.querySelector('[data-kis-account-wishlist-thumbs]');
      /* In de lade pas miniaturen ophalen als de lade open is (geen verzoeken bij elke paginaweergave) */
      this.lazy = Boolean(this.closest('dialog'));
      this.thumbsKey = null;
      this.onChange = () => this.render();
      this.onOpen = () => this.render(true);
      document.addEventListener('kis:wishlist:change', this.onChange);
      document.addEventListener('kis:wishlist:ready', this.onChange);
      document.addEventListener('kis:account:open', this.onOpen);
      this.render();
    }

    disconnectedCallback() {
      document.removeEventListener('kis:wishlist:change', this.onChange);
      document.removeEventListener('kis:wishlist:ready', this.onChange);
      document.removeEventListener('kis:account:open', this.onOpen);
    }

    list() {
      try {
        return (window.KISWishlist && window.KISWishlist.list()) || [];
      } catch (e) {
        return [];
      }
    }

    render(force) {
      const handles = this.list();
      const n = handles.length;
      if (this.textEl) {
        if (this.dataset.locked === 'true') { /* gast: 'Log in om te bekijken' blijft staan (Luc 21 okt) */ }
        else if (n === 0) this.textEl.textContent = this.dataset.empty || '';
        else if (n === 1) this.textEl.textContent = this.dataset.one || '';
        else this.textEl.textContent = (this.dataset.many || '').replace('[count]', String(n));
      }
      this.classList.toggle('has-items', n > 0);
      const dialog = this.lazy ? this.closest('dialog') : null;
      if (this.lazy && !force && !(dialog && dialog.open)) return;
      this.renderThumbs(handles.slice(0, 3));
    }

    async renderThumbs(handles) {
      if (!this.thumbsEl) return;
      const key = handles.join(',');
      if (this.thumbsKey === key) return;
      this.thumbsKey = key;
      if (!handles.length) {
        this.thumbsEl.textContent = '';
        return;
      }
      const products = await Promise.all(handles.map(productJson));
      if (this.thumbsKey !== key) return;
      this.thumbsEl.textContent = '';
      for (const product of products) {
        if (!product || !product.featured_image) continue;
        const img = document.createElement('img');
        img.src = sizedImage(product.featured_image, 96);
        img.alt = '';
        img.width = 34;
        img.height = 34;
        img.loading = 'lazy';
        this.thumbsEl.appendChild(img);
      }
    }
  }

  /* ---- Lade ---------------------------------------------------------------------------------------------------- */
  function setExpanded(state) {
    for (const trigger of document.querySelectorAll('[data-kis-account-open]')) {
      trigger.setAttribute('aria-expanded', state ? 'true' : 'false');
    }
  }

  function lockScroll() {
    const root = document.documentElement;
    const scrollbar = window.innerWidth - root.clientWidth;
    root.style.setProperty('--kis-account-sbw', (scrollbar > 0 ? scrollbar : 0) + 'px');
    root.classList.add('kis-account-lock');
  }

  function unlockScroll() {
    document.documentElement.classList.remove('kis-account-lock');
  }

  /* Dawn's mobiele menu (header-drawer) sluiten voordat de laag opent */
  function closeMenuDrawer(event) {
    const drawer = document.querySelector('header-drawer');
    if (!drawer) return;
    const details = drawer.querySelector('details[open]');
    if (!details) return;
    if (typeof drawer.closeMenuDrawer === 'function') {
      try {
        drawer.closeMenuDrawer(event || new Event('click'));
        return;
      } catch (e) {}
    }
    details.removeAttribute('open');
    document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet');
  }

  class KisAccountDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      this.body = this.dialog.querySelector('[data-kis-account-body]');
      this.closing = false;
      this.trigger = null;
      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close();
      });
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        const inside = event.clientX >= r.left && event.clientX <= r.right && event.clientY >= r.top && event.clientY <= r.bottom;
        if (!inside) this.close();
      });
      this.dialog.addEventListener('close', () => this.afterClose());
      window.KISAccount.drawer = this;
    }

    isOpen() {
      return Boolean(this.dialog && this.dialog.open && !this.closing);
    }

    open(trigger) {
      if (!this.dialog || this.dialog.open) return;
      this.trigger = trigger || (document.activeElement !== document.body ? document.activeElement : null);
      lockScroll();
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
      else this.dialog.setAttribute('open', '');
      if (this.body) this.body.scrollTop = 0;
      const show = () => this.dialog.classList.add('is-open');
      if (reduceMotion.matches) show();
      else window.requestAnimationFrame(() => window.requestAnimationFrame(show));
      setExpanded(true);
      if (this.body) this.body.focus({ preventScroll: true });
      emit('kis:account:open');
    }

    close() {
      if (!this.dialog || !this.dialog.open || this.closing) return;
      this.closing = true;
      this.dialog.classList.remove('is-open');
      const done = () => {
        if (!this.closing) return;
        this.closing = false;
        if (this.dialog.open) {
          if (typeof this.dialog.close === 'function') this.dialog.close();
          else {
            this.dialog.removeAttribute('open');
            this.afterClose();
          }
        }
      };
      if (reduceMotion.matches) {
        done();
        return;
      }
      const timer = window.setTimeout(done, 500);
      const onEnd = (event) => {
        if (event.target !== this.dialog || event.propertyName !== 'transform') return;
        this.dialog.removeEventListener('transitionend', onEnd);
        window.clearTimeout(timer);
        done();
      };
      this.dialog.addEventListener('transitionend', onEnd);
    }

    afterClose() {
      this.closing = false;
      this.dialog.classList.remove('is-open');
      unlockScroll();
      setExpanded(false);
      const trigger = this.trigger;
      this.trigger = null;
      if (trigger && typeof trigger.focus === 'function' && document.contains(trigger)) {
        trigger.focus({ preventScroll: true });
      }
      emit('kis:account:close');
    }
  }

  window.KISAccount = {
    drawer: null,
    size: Size,
    open: function (trigger) {
      if (window.KISAccount.drawer) window.KISAccount.drawer.open(trigger || null);
    },
    close: function () {
      if (window.KISAccount.drawer) window.KISAccount.drawer.close();
    },
    isOpen: function () {
      return Boolean(window.KISAccount.drawer && window.KISAccount.drawer.isOpen());
    },
  };

  if (!customElements.get('kis-account-size')) customElements.define('kis-account-size', KisAccountSize);
  if (!customElements.get('kis-account-wishlist')) customElements.define('kis-account-wishlist', KisAccountWishlist);
  if (!customElements.get('kis-account-drawer')) customElements.define('kis-account-drawer', KisAccountDrawer);

  /* Triggers: zonder laag (of zonder JS) blijft de link gewoon een link naar de accountpagina */
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-kis-account-open]');
    if (opener) {
      const drawer = window.KISAccount.drawer;
      if (!drawer || !drawer.dialog) return;
      event.preventDefault();
      closeMenuDrawer(event);
      drawer.open(opener);
      return;
    }
    if (event.target.closest('[data-kis-account-close]')) {
      event.preventDefault();
      window.KISAccount.close();
    }
  });

  /* Thema-editor: de laag tonen als de sectie gekozen wordt */
  document.addEventListener('shopify:section:select', (event) => {
    if (event.target && event.target.querySelector && event.target.querySelector('kis-account-drawer')) window.KISAccount.open();
  });
  document.addEventListener('shopify:section:deselect', (event) => {
    if (event.target && event.target.querySelector && event.target.querySelector('kis-account-drawer')) window.KISAccount.close();
  });

  function markMenuAccountLinks() {
    /* Mobiel menu: de accountnaam onderaan (ingelogd) opent de laag in plaats van een sprong naar de accountpagina */
    for (const link of document.querySelectorAll('.kis-drawer__account-name')) {
      if (!link.hasAttribute('data-kis-account-open')) {
        link.setAttribute('data-kis-account-open', '');
        link.setAttribute('aria-expanded', 'false');
      }
    }
  }

  function fixPreviewLoginLinks() {
    if (!/\.shopifypreview\.com$/i.test(window.location.hostname)) return;
    const shopHost = window.Shopify && window.Shopify.shop;
    if (!shopHost) return;
    for (const link of document.querySelectorAll('a[href*="/customer_authentication/"]')) {
      try {
        const u = new URL(link.getAttribute('href'), window.location.href);
        if (/\.shopifypreview\.com$/i.test(u.hostname)) link.setAttribute('href', 'https://' + shopHost + u.pathname + u.search);
      } catch (e) {}
    }
  }

  function openAfterLogin() {
    let params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (e) {
      return;
    }
    if (params.get('kis') !== 'account') return;
    params.delete('kis');
    const query = params.toString();
    try {
      window.history.replaceState(null, '', window.location.pathname + (query ? '?' + query : '') + window.location.hash);
    } catch (e) {}
    window.KISAccount.open();
  }

  function boot() {
    markMenuAccountLinks();
    fixPreviewLoginLinks();
    openAfterLogin();
    window.setTimeout(syncSizeOnce, 1500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', () => {
    markMenuAccountLinks();
    fixPreviewLoginLinks();
  });
})();
